import { useState } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {
  const blogs = [
    {
      title: "How to Choose the Right Tires for Your Vehicle",
      excerpt:
        "Learn the key factors in selecting the perfect tires — from tread design to seasonal performance and durability.",
      author: "Jake Thompson",
      date: "Nov 10, 2025",
      image: "/images/tires-collections.png",
      link: "/blogs/right-tires",
    },
    {
      title: "When Should You Replace Your Tires?",
      excerpt:
        "Is your car pulling to one side or your steering wheel shaking? Here’s when to book a wheel alignment before it costs more.",
      author: "Sarah Miller",
      date: "Nov 09, 2025",
      image: "/images/replace-tires.png",
      link: "/blogs/replace-tires",
    },
    {
      title: "Why Wheel Alignment Matters & How Often You Should Do It",
      excerpt:
        "Extend your tire life with expert tips on rotation, pressure checks, and seasonal storage best practices.",
      author: "David Lee",
      date: "Nov 08, 2025",
      image: "/images/installation.png",
      link: "/blogs/wheel-alignment",
    },
    {
      title: "Are EV Tires Different? What You Need to Know",
      excerpt:
        "We break down the real differences in grip, comfort, and cost — so you can make the right choice for your driving style.",
      author: "Alicia Gomez",
      date: "Nov 06, 2025",
      image: "/images/ev-tires.png",
      link: "/blogs/ev-tires",
    },
    {
      title: "How Wheel Size Affects EV Range and Ride Comfort",
      excerpt:
        "Learn why wheel balancing isn’t just about comfort — it protects your suspension, fuel economy, and tire wear.",
      author: "Ethan Walker",
      date: "Nov 05, 2025",
      image: "/images/wheels-collection.png",
      link: "/blogs/wheel-size",
    },
    {
      title: "Wireless Tire Pressure Monitoring Systems",
      excerpt:
        "Stay in control this winter. Discover the best tips for traction, braking, and tire maintenance in cold weather.",
      author: "Grace Carter",
      date: "Nov 04, 2025",
      image: "/images/wireless-system.png",
      link: "/blogs/wireless-monitoring-system",
    },
    {
      title: "How to Prepare Your Car for a Long Road Trip",
      excerpt:
        "Stay in control this winter. Discover the best tips for traction, braking, and tire maintenance in cold weather.",
      author: "Grace Carter",
      date: "Nov 04, 2025",
      image: "/images/road-trip.png",
      link: "/blogs/road-trip-prepration",
    },
    {
      title: "How Express Tire Works Ensures Hassle-Free Installations",
      excerpt:
        "Stay in control this winter. Discover the best tips for traction, braking, and tire maintenance in cold weather.",
      author: "Grace Carter",
      date: "Nov 04, 2025",
      image: "/images/wheel-alignment.png",
      link: "/blogs/hassle-free-installations",
    },
     {
      title: "The Future of Sensor-Based Wheel Alignment",
      excerpt:
        "Stay in control this winter. Discover the best tips for traction, braking, and tire maintenance in cold weather.",
      author: "Grace Carter",
      date: "Nov 04, 2025",
      image: "/images/sensor-alignment.png",
      link: "/blogs/sensor-based-alignment",
    },
     {
      title: " Understanding Wheel Torque: Why Tightening Matters More Than You Think",
      excerpt:
        "Stay in control this winter. Discover the best tips for traction, braking, and tire maintenance in cold weather.",
      author: "Grace Carter",
      date: "Nov 04, 2025",
      image: "/images/wheel-torque.png",
      link: "/blogs/wheel-torque",
    },
  ];

  const cardsPerPage = 3;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(blogs.length / cardsPerPage);

  const startIndex = (currentPage - 1) * cardsPerPage;
  const endIndex = startIndex + cardsPerPage;
  const currentBlogData = blogs.slice(startIndex, endIndex);

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen font-sans">
      <section className="relative bg-gradient-to-r from-black via-gray-900 to-yellow-600 text-white py-24 px-6 text-center overflow-hidden">
        <div className="relative z-10 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-extrabold mb-6 tracking-tight">
            🏁 Tire Talk & Auto Insights
          </h1>
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed">
            Stay informed with expert advice, automotive tips, and industry trends — brought to you by the Express Tire Works team.
          </p>
        </div>
      </section>

      <section className="py-16 px-6 max-w-7xl mx-auto">
        <h2 className="text-4xl font-bold text-gray-900 text-center mb-12">
          Featured Articles
        </h2>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {currentBlogData.map((blog, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-shadow duration-300 overflow-hidden flex flex-col border border-gray-100 group"
            >
              <div className="relative overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="w-full h-56 object-cover transform group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-yellow-500 text-black text-xs font-semibold px-3 py-1 rounded-full shadow-md">
                  {blog.date}
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow">
                <Link to={blog.link}>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 hover:text-yellow-600 transition">
                    {blog.title}
                  </h3>
                </Link>
                <p className="text-gray-600 text-sm flex-grow leading-relaxed mb-4">
                  {blog.excerpt}
                </p>
                <div className="flex items-center justify-between text-gray-500 text-xs border-t pt-3">
                  <span>By {blog.author}</span>
                  <Link
                    to={blog.link}
                    className="text-yellow-600 font-semibold hover:underline text-sm"
                  >
                    Read More →
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-center mt-14 space-x-4">
          <button
            onClick={goToPreviousPage}
            disabled={currentPage === 1}
            className={`px-5 py-2 rounded-full font-semibold transition-all duration-300 ${
              currentPage === 1
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-black text-yellow-400 hover:bg-yellow-500 hover:text-black"
            }`}
          >
            ← Previous
          </button>

          <span className="flex items-center text-gray-700 font-semibold">
            Page {currentPage} of {totalPages}
          </span>

          <button
            onClick={goToNextPage}
            disabled={currentPage === totalPages}
            className={`px-5 py-2 rounded-full font-semibold transition-all duration-300 ${
              currentPage === totalPages
                ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                : "bg-black text-yellow-400 hover:bg-yellow-500 hover:text-black"
            }`}
          >
            Next →
          </button>
        </div>
      </section>

      <section className="bg-yellow-500 text-black py-16 text-center">
        <h3 className="text-3xl md:text-4xl font-bold mb-4">
          Need Expert Advice?
        </h3>
        <p className="text-lg mb-6">
          Talk to our tire specialists today and keep your ride running at peak performance.
        </p>
        <Link
          to="/contact-us"
          className="inline-block bg-black text-yellow-400 px-6 py-3 rounded-full font-semibold hover:bg-gray-800 transition"
        >
          Contact Us →
        </Link>
      </section>
    </div>
  );
};

export default Blogs;